// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n", ""]);
// Exports
exports.locals = {
	"themes": "light-mode, dark-mode",
	"light-mode_primary": "#002e5d",
	"light-mode_secondary": "#275B74",
	"light-mode_tertiary": "#EF4A81",
	"light-mode_grayLight": "#ced4da",
	"light-mode_grayMedium": "#495057",
	"light-mode_grayDark": "#343a40",
	"light-mode_black": "#000",
	"light-mode_background": "#FCFCFC",
	"light-mode_background2": "#f8f9fa",
	"light-mode_text": "#FFFFFF",
	"light-mode_text2": "#B2B2B2",
	"dark-mode_primary": "#00B603",
	"dark-mode_secondary": "#00B603",
	"dark-mode_tertiary": "#00B603",
	"dark-mode_grayLight": "#e9ecef",
	"dark-mode_grayMedium": "#adb5bd",
	"dark-mode_grayDark": "#343a40",
	"dark-mode_black": "#1d1d1d",
	"dark-mode_background": "#343a40",
	"dark-mode_background2": "#6c757d",
	"dark-mode_text": "#f8f9fa"
};
module.exports = exports;
